package com.essntl.core.settings.data.repository

import com.essntl.core.settings.data.supabase.feature.AllowedFeatureSupabaseDataSource
import com.essntl.core.settings.data.supabase.feature.FeatureSupabaseDataSource
import com.essntl.core.settings.domain.model.feature.AllowedFeaturesModel
import com.essntl.core.settings.domain.model.feature.FeatureModel
import com.essntl.core.settings.domain.repository.FeatureRepository
import com.essntl.core.supabase.getAll
import com.essntl.core.utils.repository.Repository
import org.koin.core.annotation.Single

@Single
class FeatureRepositoryImpl internal constructor(
    private val allowedFeatureSupabaseDataSource: AllowedFeatureSupabaseDataSource,
    private val featureSupabaseDataSource: FeatureSupabaseDataSource,
) : FeatureRepository, Repository() {
    override suspend fun getFeatures(): Result<List<FeatureModel>> =
        runCatching {
            featureSupabaseDataSource
                .getAll()
                .map {
                    it.toModel()
                }
        }

    override suspend fun getAllowedFeatures(): Result<List<AllowedFeaturesModel>> =
        runCatching {
            allowedFeatureSupabaseDataSource
                .getAll()
                .map {
                    it.toModel()
                }
        }
}